import { render, staticRenderFns } from "./ProfileInfoPopupV2.vue?vue&type=template&id=bfdd52ba&scoped=true"
import script from "./ProfileInfoPopupV2.vue?vue&type=script&lang=js"
export * from "./ProfileInfoPopupV2.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfoPopupV2.vue?vue&type=style&index=0&id=bfdd52ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd52ba",
  null
  
)

export default component.exports